import HttpInterface from '../infra/http/HttpInterface';

export default class RoomService {
  constructor(readonly httpClient: HttpInterface, readonly baseUrl: string) {}

  async getRoomsAll(): Promise<any> {
    const response = await this.httpClient.request(
      `${this.baseUrl}/api/room`,
      null,
      'get'
    );
    return response.data;
  }
}
